import { FileIconLinkButton } from '@components/core-ui/form-elements/buttons/Button/variations/FileIconLinkButton';
import DownloadFileIcon from '@components/icons/DownloadFile.svg';
import FileIcon from '@components/icons/File.svg';
import LoadingIcon from '@components/icons/Loading.svg';
import { cn } from '@helpers/cn';
import { splitFileNameForMiddleTruncation } from '@helpers/splitFileNameForMiddleTruncation';
import { useRef, useState } from 'react';
import { TProps } from './types/TProps';

export const FileDownloadButton = ({ label, showLabel = true, onDownload, onError, className, testId }: TProps) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const isDownloadingRef = useRef(false);
  const { head, tail } = splitFileNameForMiddleTruncation(label);

  const download = async () => {
    if (isDownloadingRef.current) {
      return;
    }

    isDownloadingRef.current = true;
    setIsDownloading(true);
    try {
      await onDownload();
    } catch (error) {
      onError(error);
    } finally {
      isDownloadingRef.current = false;
      setIsDownloading(false);
    }
  };

  return (
    <FileIconLinkButton
      type="button"
      data-testid={testId}
      title={label}
      aria-label={showLabel ? undefined : label}
      onClick={() => void download()}
      disabled={isDownloading}
      aria-busy={isDownloading}
      className={cn('min-w-0 justify-start', className)}
    >
      {isDownloading ? (
        <LoadingIcon aria-hidden="true" className="!size-4 shrink-0 animate-spin" />
      ) : showLabel ? (
        <FileIcon aria-hidden="true" className="shrink-0" />
      ) : (
        <DownloadFileIcon aria-hidden="true" className="!size-5 shrink-0" />
      )}
      {showLabel ? (
        <span className="flex min-w-0 flex-1">
          <span className="truncate">{head}</span>
          {tail ? <span className="shrink-0">{tail}</span> : null}
        </span>
      ) : null}
    </FileIconLinkButton>
  );
};
